"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ChartTypeName = exports.ChartType = void 0;
var _react = _interopRequireDefault(require("react"));
require("./Charts.css");
var _barChart = _interopRequireDefault(require("./components/barChart.js"));
var _areaChart = _interopRequireDefault(require("./components/areaChart.js"));
var _pieChart = _interopRequireDefault(require("./components/pieChart/index.js"));
var _geoChart = _interopRequireDefault(require("./components/geoChart/geoChart.js"));
var _funnelChart = _interopRequireDefault(require("./components/funnelChart.js"));
var _gaugeChart = _interopRequireDefault(require("./components/gaugeChart/gaugeChart.js"));
var _jsxRuntime = require("react/jsx-runtime");
let ChartTypeName = exports.ChartTypeName = /*#__PURE__*/function (ChartTypeName) {
  ChartTypeName["BARCHART"] = "Bar";
  ChartTypeName["LINECHART"] = "Line";
  ChartTypeName["PIECHART"] = "Pie";
  ChartTypeName["DOUGHNUTCHART"] = "Doughnut";
  //NOT USED
  ChartTypeName["NOCHART"] = "No chart";
  ChartTypeName["AREACHART"] = "Area";
  // NOT USED
  ChartTypeName["GEOCHART"] = "Geo";
  ChartTypeName["FUNNELCHART"] = "Funnel";
  ChartTypeName["GAUGECHART"] = "Gauge";
  // NOT USED
  ChartTypeName["SCATTERPLOT"] = "Scatter Plot";
  ChartTypeName["AREABUMP"] = "Area Bump";
  ChartTypeName["BUMP"] = "Bump";
  ChartTypeName["HEATMAP"] = "Heat Map";
  ChartTypeName["RADIALBAR"] = "Radial Bar";
  ChartTypeName["CHOROPLETH"] = "Choropleth";
  ChartTypeName["STREAM"] = "Stream";
  ChartTypeName["RADAR"] = "Radar";
  ChartTypeName["TREEMAP"] = "Tree Map";
  ChartTypeName["SUNBURST"] = "Sun Burst";
  ChartTypeName["MARIMEKKO"] = "Marimekko";
  ChartTypeName["BOXPLOT"] = "Box Plot";
  ChartTypeName["BULLET"] = "Bullet";
  return ChartTypeName;
}({});
let ChartType = exports.ChartType = /*#__PURE__*/function (ChartType) {
  ChartType["BARCHART"] = "BARCHART";
  ChartType["LINECHART"] = "LINECHART";
  ChartType["PIECHART"] = "PIECHART";
  ChartType["DOUGHNUTCHART"] = "DOUGHNUTCHART";
  //NOT USED
  ChartType["NOCHART"] = "NOCHART";
  //NOT USED
  ChartType["AREACHART"] = "AREACHART";
  // NOT USED
  ChartType["GEOCHART"] = "GEOCHART";
  ChartType["FUNNELCHART"] = "FUNNELCHART";
  ChartType["GAUGECHART"] = "GAUGECHART";
  // NOT USED
  ChartType["SCATTERPLOT"] = "SCATTERPLOT";
  ChartType["AREABUMP"] = "AREABUMP";
  ChartType["BUMP"] = "BUMP";
  ChartType["HEATMAP"] = "HEATMAP";
  ChartType["RADIALBAR"] = "RADIALBAR";
  ChartType["CHOROPLETH"] = "CHOROPLETH";
  ChartType["STREAM"] = "STREAM";
  ChartType["RADAR"] = "RADAR";
  ChartType["TREEMAP"] = "TREEMAP";
  ChartType["SUNBURST"] = "SUNBURST";
  ChartType["MARIMEKKO"] = "MARIMEKKO";
  ChartType["BOXPLOT"] = "BOXPLOT";
  ChartType["BULLET"] = "BULLET";
  return ChartType;
}({});
const Charts = props => {
  var _GeoChart, _GaugeChart;
  const {
    chartType,
    geoChartData,
    geoChartOptions,
    geoChartHeight,
    geoChartWidth,
    gaugeSize,
    gaugeBarSize,
    gaugeBarColor,
    gaugeBarBaseColor,
    innerContentText,
    gaugeData,
    gaugeLabels
  } = props;
  const handleCharts = chartType => {
    switch (chartType) {
      case ChartType.BARCHART:
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_barChart.default, Object.assign({}, props));
      case ChartType.AREACHART:
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_areaChart.default, Object.assign({}, props));
      case ChartType.PIECHART:
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_pieChart.default, Object.assign({}, props));
      case ChartType.FUNNELCHART:
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_funnelChart.default, Object.assign({}, props));
      case ChartType.GEOCHART:
        return _GeoChart || (_GeoChart = /*#__PURE__*/(0, _jsxRuntime.jsx)(_geoChart.default, {
          geoChartData: geoChartData,
          geoChartHeight: geoChartHeight,
          geoChartWidth: geoChartWidth,
          geoChartOptions: geoChartOptions
        }));
      case ChartType.GAUGECHART:
        return _GaugeChart || (_GaugeChart = /*#__PURE__*/(0, _jsxRuntime.jsx)(_gaugeChart.default, {
          gaugeSize: gaugeSize,
          gaugeData: gaugeData,
          gaugeBarSize: gaugeBarSize,
          gaugeBarColor: gaugeBarColor,
          gaugeBarBaseColor: gaugeBarBaseColor,
          innerContentText: innerContentText,
          gaugeLabels: gaugeLabels
        }));
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "charts-container",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "charts-main-container",
        children: handleCharts(chartType)
      }), props.children && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "charts-controller",
        children: props.children
      })]
    })
  });
};
var _default = exports.default = Charts;